const translations = {
  fr: {
    // Header
    header: {
      contact: 'Contact',
    },
    // Hero Section
    hero: {
      title: 'Locations de Vacances d\'Exception',
      subtitle: 'Découvrez nos propriétés soigneusement sélectionnées pour des séjours inoubliables',
      cta: 'Explorer nos Propriétés',
    },
    // Properties Section
    properties: {
      title: 'Nos Propriétés',
      subtitle: 'Choisissez parmi notre sélection exclusive de locations pour vos prochaines vacances',
      guests: 'personnes',
      bedrooms: 'chambres',
      bathrooms: 'salles de bain',
      perNight: 'par nuit',
      viewDetails: 'Voir les Détails',
      villa: 'Villa',
    },
    // Property Detail Page
    propertyDetail: {
      backToProperties: 'Retour aux propriétés',
      description: 'Description',
      amenities: 'Équipements',
      availability: 'Disponibilité',
      available: 'Disponible',
      booked: 'Réservé',
      blocked: 'Indisponible',
      bookNow: 'Réserver Maintenant',
      priceRange: 'Prix',
      perNight: '/ nuit',
      guests: 'personnes max',
      bedrooms: 'chambres',
      bathrooms: 'salles de bain',
    },
    // Booking Page
    booking: {
      title: 'Demande de Réservation',
      property: 'Propriété',
      yourInfo: 'Vos Informations',
      fullName: 'Nom Complet',
      email: 'Email',
      phone: 'Téléphone',
      stayDetails: 'Détails du Séjour',
      checkIn: 'Date d\'arrivée',
      checkOut: 'Date de départ',
      guests: 'Nombre de personnes',
      message: 'Message (optionnel)',
      messagePlaceholder: 'Questions ou demandes spéciales...',
      submit: 'Envoyer la Demande',
      submitting: 'Envoi en cours...',
      successTitle: 'Demande Envoyée !',
      successMessage: 'Nous vous contacterons très bientôt pour confirmer votre réservation.',
      backToHome: 'Retour à l\'Accueil',
      errorTitle: 'Erreur',
      errorMessage: 'Une erreur est survenue. Veuillez réessayer.',
    },
    // Calendar
    calendar: {
      months: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
      weekdays: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    },
    // Contact Section
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Nous sommes à votre disposition pour toute question',
      name: 'Nom',
      phone: 'Téléphone',
      email: 'Email',
      whatsapp: 'WhatsApp',
    },
    // Footer
    footer: {
      rights: 'Tous droits réservés.',
    },
  },

  en: {
    header: {
      contact: 'Contact',
    },
    hero: {
      title: 'Exceptional Vacation Rentals',
      subtitle: 'Discover our carefully selected properties for unforgettable stays',
      cta: 'Explore Our Properties',
    },
    properties: {
      title: 'Our Properties',
      subtitle: 'Choose from our exclusive selection of rentals for your next vacation',
      guests: 'guests',
      bedrooms: 'bedrooms',
      bathrooms: 'bathrooms',
      perNight: 'per night',
      viewDetails: 'View Details',
      villa: 'Villa',
    },
    propertyDetail: {
      backToProperties: 'Back to properties',
      description: 'Description',
      amenities: 'Amenities',
      availability: 'Availability',
      available: 'Available',
      booked: 'Booked',
      blocked: 'Unavailable',
      bookNow: 'Book Now',
      priceRange: 'Price',
      perNight: '/ night',
      guests: 'guests max',
      bedrooms: 'bedrooms',
      bathrooms: 'bathrooms',
    },
    booking: {
      title: 'Booking Request',
      property: 'Property',
      yourInfo: 'Your Information',
      fullName: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      stayDetails: 'Stay Details',
      checkIn: 'Check-in Date',
      checkOut: 'Check-out Date',
      guests: 'Number of Guests',
      message: 'Message (optional)',
      messagePlaceholder: 'Questions or special requests...',
      submit: 'Send Request',
      submitting: 'Sending...',
      successTitle: 'Request Sent!',
      successMessage: 'We will contact you very soon to confirm your booking.',
      backToHome: 'Back to Home',
      errorTitle: 'Error',
      errorMessage: 'An error occurred. Please try again.',
    },
    calendar: {
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    },
    // Contact Section
    contact: {
      title: 'Contact Us',
      subtitle: 'We are at your disposal for any questions',
      name: 'Name',
      phone: 'Phone',
      email: 'Email',
      whatsapp: 'WhatsApp',
    },
    // Footer
    footer: {
      rights: 'All rights reserved.',
    },
  },

  es: {
    header: {
      contact: 'Contacto',
    },
    hero: {
      title: 'Alquileres Vacacionales Excepcionales',
      subtitle: 'Descubra nuestras propiedades cuidadosamente seleccionadas para estancias inolvidables',
      cta: 'Explorar Propiedades',
    },
    properties: {
      title: 'Nuestras Propiedades',
      subtitle: 'Elija entre nuestra selección exclusiva de alquileres para sus próximas vacaciones',
      guests: 'personas',
      bedrooms: 'habitaciones',
      bathrooms: 'baños',
      perNight: 'por noche',
      viewDetails: 'Ver Detalles',
      villa: 'Villa',
    },
    propertyDetail: {
      backToProperties: 'Volver a propiedades',
      description: 'Descripción',
      amenities: 'Comodidades',
      availability: 'Disponibilidad',
      available: 'Disponible',
      booked: 'Reservado',
      blocked: 'No disponible',
      bookNow: 'Reservar Ahora',
      priceRange: 'Precio',
      perNight: '/ noche',
      guests: 'personas máx',
      bedrooms: 'habitaciones',
      bathrooms: 'baños',
    },
    booking: {
      title: 'Solicitud de Reserva',
      property: 'Propiedad',
      yourInfo: 'Su Información',
      fullName: 'Nombre Completo',
      email: 'Correo Electrónico',
      phone: 'Teléfono',
      stayDetails: 'Detalles de la Estancia',
      checkIn: 'Fecha de Llegada',
      checkOut: 'Fecha de Salida',
      guests: 'Número de Personas',
      message: 'Mensaje (opcional)',
      messagePlaceholder: 'Preguntas o solicitudes especiales...',
      submit: 'Enviar Solicitud',
      submitting: 'Enviando...',
      successTitle: '¡Solicitud Enviada!',
      successMessage: 'Nos pondremos en contacto muy pronto para confirmar su reserva.',
      backToHome: 'Volver al Inicio',
      errorTitle: 'Error',
      errorMessage: 'Ocurrió un error. Por favor, inténtelo de nuevo.',
    },
    calendar: {
      months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      weekdays: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    },
    // Contact Section
    contact: {
      title: 'Contáctenos',
      subtitle: 'Estamos a su disposición para cualquier pregunta',
      name: 'Nombre',
      phone: 'Teléfono',
      email: 'Correo electrónico',
      whatsapp: 'WhatsApp',
    },
    // Footer
    footer: {
      rights: 'Todos los derechos reservados.',
    },
  },

  de: {
    header: {
      contact: 'Kontakt',
    },
    hero: {
      title: 'Außergewöhnliche Ferienvermietungen',
      subtitle: 'Entdecken Sie unsere sorgfältig ausgewählten Unterkünfte für unvergessliche Aufenthalte',
      cta: 'Unterkünfte Entdecken',
    },
    properties: {
      title: 'Unsere Unterkünfte',
      subtitle: 'Wählen Sie aus unserer exklusiven Auswahl an Mietobjekten für Ihren nächsten Urlaub',
      guests: 'Gäste',
      bedrooms: 'Schlafzimmer',
      bathrooms: 'Badezimmer',
      perNight: 'pro Nacht',
      viewDetails: 'Details Anzeigen',
      villa: 'Villa',
    },
    propertyDetail: {
      backToProperties: 'Zurück zu Unterkünften',
      description: 'Beschreibung',
      amenities: 'Ausstattung',
      availability: 'Verfügbarkeit',
      available: 'Verfügbar',
      booked: 'Gebucht',
      blocked: 'Nicht verfügbar',
      bookNow: 'Jetzt Buchen',
      priceRange: 'Preis',
      perNight: '/ Nacht',
      guests: 'Gäste max',
      bedrooms: 'Schlafzimmer',
      bathrooms: 'Badezimmer',
    },
    booking: {
      title: 'Buchungsanfrage',
      property: 'Unterkunft',
      yourInfo: 'Ihre Informationen',
      fullName: 'Vollständiger Name',
      email: 'E-Mail',
      phone: 'Telefon',
      stayDetails: 'Aufenthaltsdetails',
      checkIn: 'Anreisedatum',
      checkOut: 'Abreisedatum',
      guests: 'Anzahl der Gäste',
      message: 'Nachricht (optional)',
      messagePlaceholder: 'Fragen oder besondere Wünsche...',
      submit: 'Anfrage Senden',
      submitting: 'Wird gesendet...',
      successTitle: 'Anfrage Gesendet!',
      successMessage: 'Wir werden Sie sehr bald kontaktieren, um Ihre Buchung zu bestätigen.',
      backToHome: 'Zurück zur Startseite',
      errorTitle: 'Fehler',
      errorMessage: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    },
    calendar: {
      months: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
      weekdays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    },
    // Contact Section
    contact: {
      title: 'Kontaktieren Sie uns',
      subtitle: 'Wir stehen Ihnen für Fragen zur Verfügung',
      name: 'Name',
      phone: 'Telefon',
      email: 'E-Mail',
      whatsapp: 'WhatsApp',
    },
    // Footer
    footer: {
      rights: 'Alle Rechte vorbehalten.',
    },
  },

  it: {
    header: {
      contact: 'Contatto',
    },
    hero: {
      title: 'Affitti Vacanze Eccezionali',
      subtitle: 'Scoprite le nostre proprietà accuratamente selezionate per soggiorni indimenticabili',
      cta: 'Esplora le Proprietà',
    },
    properties: {
      title: 'Le Nostre Proprietà',
      subtitle: 'Scegliete dalla nostra selezione esclusiva di affitti per le vostre prossime vacanze',
      guests: 'ospiti',
      bedrooms: 'camere',
      bathrooms: 'bagni',
      perNight: 'a notte',
      viewDetails: 'Vedi Dettagli',
      villa: 'Villa',
    },
    propertyDetail: {
      backToProperties: 'Torna alle proprietà',
      description: 'Descrizione',
      amenities: 'Servizi',
      availability: 'Disponibilità',
      available: 'Disponibile',
      booked: 'Prenotato',
      blocked: 'Non disponibile',
      bookNow: 'Prenota Ora',
      priceRange: 'Prezzo',
      perNight: '/ notte',
      guests: 'ospiti max',
      bedrooms: 'camere',
      bathrooms: 'bagni',
    },
    booking: {
      title: 'Richiesta di Prenotazione',
      property: 'Proprietà',
      yourInfo: 'Le Tue Informazioni',
      fullName: 'Nome Completo',
      email: 'Email',
      phone: 'Telefono',
      stayDetails: 'Dettagli del Soggiorno',
      checkIn: 'Data di Arrivo',
      checkOut: 'Data di Partenza',
      guests: 'Numero di Ospiti',
      message: 'Messaggio (opzionale)',
      messagePlaceholder: 'Domande o richieste speciali...',
      submit: 'Invia Richiesta',
      submitting: 'Invio in corso...',
      successTitle: 'Richiesta Inviata!',
      successMessage: 'Vi contatteremo molto presto per confermare la vostra prenotazione.',
      backToHome: 'Torna alla Home',
      errorTitle: 'Errore',
      errorMessage: 'Si è verificato un errore. Riprova.',
    },
    calendar: {
      months: ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'],
      weekdays: ['Dom', 'Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab'],
    },
    // Contact Section
    contact: {
      title: 'Contattaci',
      subtitle: 'Siamo a vostra disposizione per qualsiasi domanda',
      name: 'Nome',
      phone: 'Telefono',
      email: 'Email',
      whatsapp: 'WhatsApp',
    },
    // Footer
    footer: {
      rights: 'Tutti i diritti riservati.',
    },
  },

  nl: {
    header: {
      contact: 'Contact',
    },
    hero: {
      title: 'Uitzonderlijke Vakantiewoningen',
      subtitle: 'Ontdek onze zorgvuldig geselecteerde accommodaties voor onvergetelijke verblijven',
      cta: 'Ontdek Onze Woningen',
    },
    properties: {
      title: 'Onze Woningen',
      subtitle: 'Kies uit onze exclusieve selectie van huurwoningen voor uw volgende vakantie',
      guests: 'gasten',
      bedrooms: 'slaapkamers',
      bathrooms: 'badkamers',
      perNight: 'per nacht',
      viewDetails: 'Details Bekijken',
      villa: 'Villa',
    },
    propertyDetail: {
      backToProperties: 'Terug naar woningen',
      description: 'Beschrijving',
      amenities: 'Voorzieningen',
      availability: 'Beschikbaarheid',
      available: 'Beschikbaar',
      booked: 'Geboekt',
      blocked: 'Niet beschikbaar',
      bookNow: 'Nu Boeken',
      priceRange: 'Prijs',
      perNight: '/ nacht',
      guests: 'gasten max',
      bedrooms: 'slaapkamers',
      bathrooms: 'badkamers',
    },
    booking: {
      title: 'Boekingsaanvraag',
      property: 'Woning',
      yourInfo: 'Uw Gegevens',
      fullName: 'Volledige Naam',
      email: 'E-mail',
      phone: 'Telefoon',
      stayDetails: 'Verblijfsdetails',
      checkIn: 'Aankomstdatum',
      checkOut: 'Vertrekdatum',
      guests: 'Aantal Gasten',
      message: 'Bericht (optioneel)',
      messagePlaceholder: 'Vragen of speciale verzoeken...',
      submit: 'Aanvraag Versturen',
      submitting: 'Verzenden...',
      successTitle: 'Aanvraag Verzonden!',
      successMessage: 'We nemen zeer binnenkort contact met u op om uw boeking te bevestigen.',
      backToHome: 'Terug naar Home',
      errorTitle: 'Fout',
      errorMessage: 'Er is een fout opgetreden. Probeer het opnieuw.',
    },
    calendar: {
      months: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
      weekdays: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
    },
    // Contact Section
    contact: {
      title: 'Contact opnemen',
      subtitle: 'We staan tot uw beschikking voor vragen',
      name: 'Naam',
      phone: 'Telefoon',
      email: 'E-mail',
      whatsapp: 'WhatsApp',
    },
    // Footer
    footer: {
      rights: 'Alle rechten voorbehouden.',
    },
  },

  ru: {
    header: {
      contact: 'Контакт',
    },
    hero: {
      title: 'Исключительная Аренда для Отдыха',
      subtitle: 'Откройте для себя наши тщательно подобранные объекты для незабываемого отдыха',
      cta: 'Посмотреть Объекты',
    },
    properties: {
      title: 'Наши Объекты',
      subtitle: 'Выберите из нашей эксклюзивной подборки аренды для вашего следующего отпуска',
      guests: 'гостей',
      bedrooms: 'спален',
      bathrooms: 'ванных',
      perNight: 'за ночь',
      viewDetails: 'Подробнее',
      villa: 'Вилла',
    },
    propertyDetail: {
      backToProperties: 'Назад к объектам',
      description: 'Описание',
      amenities: 'Удобства',
      availability: 'Доступность',
      available: 'Доступно',
      booked: 'Забронировано',
      blocked: 'Недоступно',
      bookNow: 'Забронировать',
      priceRange: 'Цена',
      perNight: '/ ночь',
      guests: 'гостей макс',
      bedrooms: 'спален',
      bathrooms: 'ванных',
    },
    booking: {
      title: 'Запрос на Бронирование',
      property: 'Объект',
      yourInfo: 'Ваши Данные',
      fullName: 'Полное Имя',
      email: 'Эл. почта',
      phone: 'Телефон',
      stayDetails: 'Детали Проживания',
      checkIn: 'Дата Заезда',
      checkOut: 'Дата Выезда',
      guests: 'Количество Гостей',
      message: 'Сообщение (необязательно)',
      messagePlaceholder: 'Вопросы или особые пожелания...',
      submit: 'Отправить Запрос',
      submitting: 'Отправка...',
      successTitle: 'Запрос Отправлен!',
      successMessage: 'Мы свяжемся с вами в ближайшее время для подтверждения бронирования.',
      backToHome: 'На Главную',
      errorTitle: 'Ошибка',
      errorMessage: 'Произошла ошибка. Пожалуйста, попробуйте снова.',
    },
    calendar: {
      months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
      weekdays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    },
    // Contact Section
    contact: {
      title: 'Свяжитесь с нами',
      subtitle: 'Мы в вашем распоряжении по любым вопросам',
      name: 'Имя',
      phone: 'Телефон',
      email: 'Электронная почта',
      whatsapp: 'WhatsApp',
    },
    // Footer
    footer: {
      rights: 'Все права защищены.',
    },
  },

  ar: {
    header: {
      contact: 'اتصل بنا',
    },
    hero: {
      title: 'إيجارات عطلات استثنائية',
      subtitle: 'اكتشف عقاراتنا المختارة بعناية لإقامات لا تُنسى',
      cta: 'استكشف العقارات',
    },
    properties: {
      title: 'عقاراتنا',
      subtitle: 'اختر من مجموعتنا الحصرية من الإيجارات لعطلتك القادمة',
      guests: 'ضيوف',
      bedrooms: 'غرف نوم',
      bathrooms: 'حمامات',
      perNight: 'لليلة',
      viewDetails: 'عرض التفاصيل',
      villa: 'فيلا',
    },
    propertyDetail: {
      backToProperties: 'العودة إلى العقارات',
      description: 'الوصف',
      amenities: 'المرافق',
      availability: 'التوفر',
      available: 'متاح',
      booked: 'محجوز',
      blocked: 'غير متاح',
      bookNow: 'احجز الآن',
      priceRange: 'السعر',
      perNight: '/ ليلة',
      guests: 'ضيوف كحد أقصى',
      bedrooms: 'غرف نوم',
      bathrooms: 'حمامات',
    },
    booking: {
      title: 'طلب الحجز',
      property: 'العقار',
      yourInfo: 'معلوماتك',
      fullName: 'الاسم الكامل',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      stayDetails: 'تفاصيل الإقامة',
      checkIn: 'تاريخ الوصول',
      checkOut: 'تاريخ المغادرة',
      guests: 'عدد الضيوف',
      message: 'رسالة (اختياري)',
      messagePlaceholder: 'أسئلة أو طلبات خاصة...',
      submit: 'إرسال الطلب',
      submitting: 'جاري الإرسال...',
      successTitle: 'تم إرسال الطلب!',
      successMessage: 'سنتصل بك قريباً جداً لتأكيد حجزك.',
      backToHome: 'العودة للرئيسية',
      errorTitle: 'خطأ',
      errorMessage: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
    },
    calendar: {
      months: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
      weekdays: ['أحد', 'إثن', 'ثلا', 'أرب', 'خمي', 'جمع', 'سبت'],
    },
    // Contact Section
    contact: {
      title: 'اتصل بنا',
      subtitle: 'نحن في خدمتكم لأية أسئلة',
      name: 'الاسم',
      phone: 'الهاتف',
      email: 'البريد الإلكتروني',
      whatsapp: 'واتساب',
    },
    // Footer
    footer: {
      rights: 'جميع الحقوق محفوظة.',
    },
  },

  zh: {
    header: {
      contact: '联系方式',
    },
    hero: {
      title: '卓越度假租赁',
      subtitle: '探索我们精心挑选的物业，享受难忘的住宿体验',
      cta: '探索物业',
    },
    properties: {
      title: '我们的物业',
      subtitle: '从我们的独家精选中选择您下一个假期的租赁',
      guests: '位客人',
      bedrooms: '间卧室',
      bathrooms: '间浴室',
      perNight: '每晚',
      viewDetails: '查看详情',
      villa: '别墅',
    },
    propertyDetail: {
      backToProperties: '返回物业列表',
      description: '描述',
      amenities: '设施',
      availability: '可用性',
      available: '可用',
      booked: '已预订',
      blocked: '不可用',
      bookNow: '立即预订',
      priceRange: '价格',
      perNight: '/ 晚',
      guests: '最多客人',
      bedrooms: '间卧室',
      bathrooms: '间浴室',
    },
    booking: {
      title: '预订请求',
      property: '物业',
      yourInfo: '您的信息',
      fullName: '全名',
      email: '电子邮件',
      phone: '电话',
      stayDetails: '住宿详情',
      checkIn: '入住日期',
      checkOut: '退房日期',
      guests: '客人数量',
      message: '留言（可选）',
      messagePlaceholder: '问题或特殊要求...',
      submit: '发送请求',
      submitting: '发送中...',
      successTitle: '请求已发送！',
      successMessage: '我们会尽快与您联系确认预订。',
      backToHome: '返回首页',
      errorTitle: '错误',
      errorMessage: '发生错误，请重试。',
    },
    calendar: {
      months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
      weekdays: ['日', '一', '二', '三', '四', '五', '六'],
    },
    // Contact Section
    contact: {
      title: '联系我们',
      subtitle: '如有任何问题，我们随时为您服务',
      name: '姓名',
      phone: '电话',
      email: '电子邮件',
      whatsapp: 'WhatsApp',
    },
    // Footer
    footer: {
      rights: '版权所有。',
    },
  },

  ja: {
    header: {
      contact: 'お問い合わせ',
    },
    hero: {
      title: '特別なバケーションレンタル',
      subtitle: '忘れられない滞在のために厳選された物件をご覧ください',
      cta: '物件を探す',
    },
    properties: {
      title: '物件一覧',
      subtitle: '次のバケーションのための厳選されたレンタルからお選びください',
      guests: '名',
      bedrooms: '寝室',
      bathrooms: 'バスルーム',
      perNight: '1泊',
      viewDetails: '詳細を見る',
      villa: 'ヴィラ',
    },
    propertyDetail: {
      backToProperties: '物件一覧に戻る',
      description: '説明',
      amenities: '設備',
      availability: '空室状況',
      available: '空室',
      booked: '予約済み',
      blocked: '利用不可',
      bookNow: '予約する',
      priceRange: '料金',
      perNight: '/ 泊',
      guests: '名まで',
      bedrooms: '寝室',
      bathrooms: 'バスルーム',
    },
    booking: {
      title: '予約リクエスト',
      property: '物件',
      yourInfo: 'お客様情報',
      fullName: '氏名',
      email: 'メールアドレス',
      phone: '電話番号',
      stayDetails: '滞在詳細',
      checkIn: 'チェックイン日',
      checkOut: 'チェックアウト日',
      guests: '人数',
      message: 'メッセージ（任意）',
      messagePlaceholder: 'ご質問やご要望...',
      submit: 'リクエストを送信',
      submitting: '送信中...',
      successTitle: 'リクエスト送信完了！',
      successMessage: '予約確認のため、すぐにご連絡いたします。',
      backToHome: 'ホームに戻る',
      errorTitle: 'エラー',
      errorMessage: 'エラーが発生しました。もう一度お試しください。',
    },
    calendar: {
      months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
      weekdays: ['日', '月', '火', '水', '木', '金', '土'],
    },
    // Contact Section
    contact: {
      title: 'お問い合わせ',
      subtitle: 'ご質問がございましたらお気軽にどうぞ',
      name: '名前',
      phone: '電話',
      email: 'メール',
      whatsapp: 'WhatsApp',
    },
    // Footer
    footer: {
      rights: '全著作権所有。',
    },
  },

  ko: {
    header: {
      contact: '연락처',
    },
    hero: {
      title: '특별한 휴가 렌탈',
      subtitle: '잊을 수 없는 숙박을 위해 엄선된 숙소를 만나보세요',
      cta: '숙소 둘러보기',
    },
    properties: {
      title: '숙소 목록',
      subtitle: '다음 휴가를 위한 엄선된 렌탈 중에서 선택하세요',
      guests: '명',
      bedrooms: '침실',
      bathrooms: '욕실',
      perNight: '1박',
      viewDetails: '상세 보기',
      villa: '빌라',
    },
    propertyDetail: {
      backToProperties: '숙소 목록으로',
      description: '설명',
      amenities: '편의시설',
      availability: '예약 가능 여부',
      available: '예약 가능',
      booked: '예약됨',
      blocked: '이용 불가',
      bookNow: '예약하기',
      priceRange: '가격',
      perNight: '/ 박',
      guests: '최대 인원',
      bedrooms: '침실',
      bathrooms: '욕실',
    },
    booking: {
      title: '예약 요청',
      property: '숙소',
      yourInfo: '고객 정보',
      fullName: '성명',
      email: '이메일',
      phone: '전화번호',
      stayDetails: '숙박 상세',
      checkIn: '체크인 날짜',
      checkOut: '체크아웃 날짜',
      guests: '인원 수',
      message: '메시지 (선택사항)',
      messagePlaceholder: '질문이나 특별 요청사항...',
      submit: '요청 보내기',
      submitting: '전송 중...',
      successTitle: '요청 완료!',
      successMessage: '예약 확인을 위해 곧 연락드리겠습니다.',
      backToHome: '홈으로',
      errorTitle: '오류',
      errorMessage: '오류가 발생했습니다. 다시 시도해주세요.',
    },
    calendar: {
      months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
      weekdays: ['일', '월', '화', '수', '목', '금', '토'],
    },
    // Contact Section
    contact: {
      title: '문의하기',
      subtitle: '궁금한 점이 있으시면 언제든지 연락주세요',
      name: '이름',
      phone: '전화',
      email: '이메일',
      whatsapp: 'WhatsApp',
    },
    // Footer
    footer: {
      rights: '모든 권리 보유.',
    },
  },

  hi: {
    header: {
      contact: 'संपर्क',
    },
    hero: {
      title: 'असाधारण छुट्टी किराये',
      subtitle: 'यादगार प्रवास के लिए हमारी सावधानीपूर्वक चुनी गई संपत्तियों की खोज करें',
      cta: 'संपत्तियां देखें',
    },
    properties: {
      title: 'हमारी संपत्तियां',
      subtitle: 'अपनी अगली छुट्टी के लिए हमारे विशेष किराये के चयन में से चुनें',
      guests: 'मेहमान',
      bedrooms: 'शयनकक्ष',
      bathrooms: 'स्नानघर',
      perNight: 'प्रति रात',
      viewDetails: 'विवरण देखें',
      villa: 'विला',
    },
    propertyDetail: {
      backToProperties: 'संपत्तियों पर वापस',
      description: 'विवरण',
      amenities: 'सुविधाएं',
      availability: 'उपलब्धता',
      available: 'उपलब्ध',
      booked: 'बुक किया गया',
      blocked: 'अनुपलब्ध',
      bookNow: 'अभी बुक करें',
      priceRange: 'मूल्य',
      perNight: '/ रात',
      guests: 'अधिकतम मेहमान',
      bedrooms: 'शयनकक्ष',
      bathrooms: 'स्नानघर',
    },
    booking: {
      title: 'बुकिंग अनुरोध',
      property: 'संपत्ति',
      yourInfo: 'आपकी जानकारी',
      fullName: 'पूरा नाम',
      email: 'ईमेल',
      phone: 'फ़ोन',
      stayDetails: 'प्रवास विवरण',
      checkIn: 'चेक-इन तिथि',
      checkOut: 'चेक-आउट तिथि',
      guests: 'मेहमानों की संख्या',
      message: 'संदेश (वैकल्पिक)',
      messagePlaceholder: 'प्रश्न या विशेष अनुरोध...',
      submit: 'अनुरोध भेजें',
      submitting: 'भेज रहे हैं...',
      successTitle: 'अनुरोध भेजा गया!',
      successMessage: 'आपकी बुकिंग की पुष्टि के लिए हम जल्द ही संपर्क करेंगे।',
      backToHome: 'होम पर वापस',
      errorTitle: 'त्रुटि',
      errorMessage: 'एक त्रुटि हुई। कृपया पुन: प्रयास करें।',
    },
    calendar: {
      months: ['जनवरी', 'फ़रवरी', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुलाई', 'अगस्त', 'सितंबर', 'अक्टूबर', 'नवंबर', 'दिसंबर'],
      weekdays: ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरु', 'शुक्र', 'शनि'],
    },
    // Contact Section
    contact: {
      title: 'हमसे संपर्क करें',
      subtitle: 'किसी भी प्रश्न के लिए हम आपकी सेवा में हैं',
      name: 'नाम',
      phone: 'फोन',
      email: 'ईमेल',
      whatsapp: 'WhatsApp',
    },
    // Footer
    footer: {
      rights: 'सर्वाधिकार सुरक्षित।',
    },
  },
};

export default translations;
